import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgVisa = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 96,
	height: 96,
	viewBox: "0 0 96 96",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("rect", {
		width: 96,
		height: 96,
		fill: "#1434CB"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M58.5939 36.6595C53.6238 36.6595 49.1821 39.236 49.1821 43.9952C49.1821 49.4536 57.0594 49.8306 57.0594 52.5732C57.0594 53.7279 55.7364 54.7614 53.476 54.7614C50.2689 54.7614 47.8718 53.3173 47.8718 53.3173L46.8459 58.1206C46.8459 58.1206 49.6074 59.3405 53.2735 59.3405C58.7074 59.3405 62.9838 56.6379 62.9838 51.7968C62.9838 46.0286 55.0736 45.6628 55.0736 43.1179C55.0736 42.2133 56.1597 41.2225 58.4131 41.2225C60.956 41.2225 63.03 42.2729 63.03 42.2729L64.0341 37.6342C64.0341 37.6342 61.7765 36.6595 58.5932 36.6595H58.5939ZM13.1205 37.0099L13 37.7099C13 37.7099 15.0909 38.0925 16.9744 38.8562C19.3995 39.7314 19.5719 40.2415 19.9804 41.8237L24.4305 58.979H30.3963L39.5867 37.0099H33.6349L27.7294 51.9467L25.3197 39.2851C25.099 37.836 23.9793 37.0092 22.6094 37.0092H13.1212L13.1205 37.0099ZM41.9803 37.0099L37.3115 58.979H42.9872L47.6391 37.0099H41.9803ZM73.6351 37.0099C72.2667 37.0099 71.5414 37.7428 71.0096 39.023L62.6944 58.979H68.6462L69.7974 55.6527H77.0483L77.7483 58.979H83L78.4188 37.0099H73.6351ZM74.4094 42.9455L76.1738 51.1893H71.4476L74.4101 42.9455H74.4094Z",
		fill: "white"
	})]
});
export default SvgVisa;
